<div class="column">
    <div class="row">
        <div class="search">
            <mat-icon matPrefix svgIcon="search" color="accent"></mat-icon>
            <input type="search" placeholder="Search"
                class='mat-body secondary-border-element background-text-element text-input' [formControl]='search'
                list='searchDataList' #searchInput tabindex="1">
        </div>
        <div class="search-option">
            <button mat-button [matMenuTriggerFor]="searchOption">
                <span class='mat-body flex-center'><span class='v-middle'>Search by: {{currentSearchOption}}</span>
                    <mat-icon svgIcon="dropdownMenu" class="secondary-contrast-icon"></mat-icon>
                </span>
            </button>
            <mat-menu #searchOption="matMenu" xPosition="before">
                <button (click)="setSearchOption(SearchOptionsEnum.userName)" mat-menu-item>Name</button>
                <button (click)="setSearchOption(SearchOptionsEnum.email)" mat-menu-item>E-mail</button>
                <button (click)="setSearchOption(SearchOptionsEnum.clinicId)" mat-menu-item>Clinic ID</button>

            </mat-menu>
        </div>
        <div class="spacer"></div>

        <button mat-raised-button color="accent" id="logout-btn" (click)="showCreateNewUserDialog()">Add new
            user</button>

    </div>
    <app-home-table></app-home-table>
</div>


<p class="mat-small background-text-element version">v{{version}}&nbsp;|&nbsp;Environment: {{environmentName}}&nbsp;|&nbsp;Build datetime: {{buildDateTime|date:'MM/dd/yyyy, h:mm a'}}</p>